import styled, { css } from 'styled-components';

export const StyledWrapper = styled.div`
	width: 100%;
	background: #FFF;
	z-index: 10;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 16px;

	transition: bottom 0.3s linear;

	* {
		flex: 1;
	}

	${({ isSticky }) => !isSticky && css`
		height: 1px;
		width: 100%;
		* {
			display: none;
		}
	`}
`;
